import styled from 'styled-components';
import { Alert } from '@mui/material';

const StyledIframe = styled.iframe`
  width: 100%;
  height: 3600px;
  border: 0;
  display: block;
`;

const StyledAlert = styled(Alert)`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 15px;
  border-radius: 5px;
  cursor: pointer;
  
`;

export {
  StyledIframe,
  StyledAlert,
};
